__turbopack_context__.v({
  "animateHeight": "QuickSearchCompactList-module__w0xWna__animateHeight",
  "compactInputRow": "QuickSearchCompactList-module__w0xWna__compactInputRow",
  "compactResultsPanel": "QuickSearchCompactList-module__w0xWna__compactResultsPanel",
  "compactShell": "QuickSearchCompactList-module__w0xWna__compactShell",
  "listBoxScrollArea": "QuickSearchCompactList-module__w0xWna__listBoxScrollArea",
  "listContentArea": "QuickSearchCompactList-module__w0xWna__listContentArea",
  "noResultsContainer": "QuickSearchCompactList-module__w0xWna__noResultsContainer",
  "searchResultsContainer": "QuickSearchCompactList-module__w0xWna__searchResultsContainer",
});
